import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimAutomation extends IModelBase {
  TemplateId: number
  ClaimExportId: number
  PayerId: string
  ClaimExportTypeId: string
  ClaimTypeId: string
  ConfigId: number
  NewExportId: number
}

@Injectable()
export class ClaimAutomationODataService extends ODataService<IClaimAutomation> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimAutomations'
  }
}
